import React from "react";

/**
 * RouterCardIcon — state-aware landscape route card.
 *   "pending"  → grey dashed rectangle, empty interior
 *   "complete" → green border, black grid, red first cell filled
 * A 3rd fallback keeps the original full-colour variant for release-notes /
 * legends.
 */
export default function RouterCardIcon({ size = 14, state, className = "" }) {
  const s = size;
  const baseProps = {
    width: s * 1.3,
    height: s,
    viewBox: "0 0 18 14",
    className,
    "aria-hidden": "true",
  };

  if (state === "pending") {
    return (
      <svg {...baseProps}>
        <rect
          x="1"
          y="1"
          width="16"
          height="12"
          rx="1"
          fill="none"
          stroke="#94a3b8"
          strokeWidth="1"
          strokeDasharray="2 1.6"
        />
      </svg>
    );
  }

  if (state === "complete") {
    return (
      <svg {...baseProps}>
        {/* Paper body — green border */}
        <rect x="1" y="1" width="16" height="12" rx="1" fill="#fffaf0" stroke="#10b981" strokeWidth="1" />
        {/* Grid — vertical */}
        <line x1="5" y1="1.5" x2="5" y2="12.5" stroke="#334155" strokeWidth="0.4" />
        <line x1="9" y1="1.5" x2="9" y2="12.5" stroke="#334155" strokeWidth="0.4" />
        <line x1="13" y1="1.5" x2="13" y2="12.5" stroke="#334155" strokeWidth="0.4" />
        {/* Grid — horizontal */}
        <line x1="1.5" y1="4" x2="16.5" y2="4" stroke="#334155" strokeWidth="0.4" />
        <line x1="1.5" y1="7" x2="16.5" y2="7" stroke="#334155" strokeWidth="0.4" />
        <line x1="1.5" y1="10" x2="16.5" y2="10" stroke="#334155" strokeWidth="0.4" />
        {/* First cell filled red */}
        <rect x="1.5" y="1.5" width="3.5" height="2.5" fill="#dc2626" />
      </svg>
    );
  }

  /* Fallback — full-colour legend variant */
  return (
    <svg {...baseProps}>
      <rect x="1" y="1" width="16" height="12" rx="1" fill="#fffaf0" stroke="#dc2626" strokeWidth="1" />
      <line x1="5" y1="1.5" x2="5" y2="12.5" stroke="#0f172a" strokeWidth="0.4" />
      <line x1="9" y1="1.5" x2="9" y2="12.5" stroke="#0f172a" strokeWidth="0.4" />
      <line x1="13" y1="1.5" x2="13" y2="12.5" stroke="#0f172a" strokeWidth="0.4" />
      <line x1="1.5" y1="4" x2="16.5" y2="4" stroke="#0f172a" strokeWidth="0.4" />
      <line x1="1.5" y1="7" x2="16.5" y2="7" stroke="#0f172a" strokeWidth="0.4" />
      <line x1="1.5" y1="10" x2="16.5" y2="10" stroke="#0f172a" strokeWidth="0.4" />
      <rect x="1.5" y="1.5" width="3" height="2" fill="#fca5a5" opacity="0.6" />
    </svg>
  );
}
